import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SearchIcon } from "./assets";
import { fetchFaqsItems } from "./redux/slices/FaqsThunks";

export default function Faq() {
  const dispatch = useDispatch();
  const faqsItems = useSelector((state) => state.faqs.items);

  useEffect(() => {
    dispatch(fetchFaqsItems());
  }, []);

  return (
    <RootWrapperFaq>
      <Dashboard>
        <Wrapper>
          <Frame1502>
            <Frame1502_0001>
              <Frame1515>
                <SectionFaqSection>
                  <Frame24>
                    <IconBadge>
                      <IconFilled src={SearchIcon} alt="icon" />
                      <Faq_0001>FAQ</Faq_0001>
                    </IconBadge>
                    <FrequentlyAskedQuestions>
                      Frequently asked questions
                    </FrequentlyAskedQuestions>
                    <FindAnswersToCommonQueriesAboutPaartnerVendorsAndItsRewards>
                      Find answers to common queries about Paartner, vendors and
                      its rewards.
                    </FindAnswersToCommonQueriesAboutPaartnerVendorsAndItsRewards>
                  </Frame24>

                  <PRTNR.FAQ faqItems={faqsItems} />
                </SectionFaqSection>
              </Frame1515>
            </Frame1502_0001>
          </Frame1502>
        </Wrapper>
      </Dashboard>
    </RootWrapperFaq>
  );
}

const RootWrapperFaq = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  box-sizing: border-box;
  padding: 68px 0px;
  flex-shrink: 0;
`;

const Frame1502 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1502_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  width: 1200px;
  box-sizing: border-box;
`;

const Frame1515 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 10px;
  border-radius: 16px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 10px;
`;

const SectionFaqSection = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 32px;
  box-sizing: border-box;
`;

const Frame24 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const IconBadge = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  border-radius: 999px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding-right: 16px;
`;

const IconFilled = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const Faq_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

const FrequentlyAskedQuestions = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const FindAnswersToCommonQueriesAboutPaartnerVendorsAndItsRewards = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;
